import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const Container = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

type Props = {
  threadsMetadata: {
    page: number;
    total: number;
    limit: number;
  } | null;
};

export const UserThreadsMetadataResults = (props: Props) => {
  const { threadsMetadata } = props;

  if (!threadsMetadata) return null;

  return (
    <Container>
      <Typography variant="body2">
        Showing {threadsMetadata.total} results
      </Typography>
    </Container>
  );
};
